export const PROGRAM_TUB = "PROGRAM_TUB";
export const DOCUMENT_TUB = "DOCUMENT_TUB";
export const IOS_OS = "IOS_OS";
export const ANDROID_OS = "ANDROID_OS";
export const LINK_TO_DOCUMENTS =
  "https://drive.google.com/drive/u/0/folders/1fJMMo2TZGVqVMbwKppv3igxpUTt9RLKx";
